export default "__VITE_ASSET__15f02c56__"